import { NavLink, Route, Routes } from 'react-router-dom'
import { benutzername, hat_rolle, melde_ab } from './anmeldung'
import Uebersicht from './seiten/Uebersicht'
import Kunden from './seiten/Kunden'
import Kundenakte from './seiten/Kundenakte'
import Vertraege from './seiten/Vertraege'
import Vertragsakte from './seiten/Vertragsakte'
import Rechnungen from './seiten/Rechnungen'
import Rechnungsblatt from './seiten/Rechnungsblatt'
import Debitoren from './seiten/Debitoren'
import Marktkommunikation from './seiten/Marktkommunikation'
import Bilanzierung from './seiten/Bilanzierung'
import Vertrieb from './seiten/Vertrieb'
import Produkte from './seiten/Produkte'
import Stromkennzeichnung from './seiten/Stromkennzeichnung'
import Aufbewahrung from './seiten/Aufbewahrung'

/** Ein Eintrag der Seitenleiste mit den Rollen, die ihn sehen duerfen. */
const bereiche = [
  { pfad: '/', name: 'Übersicht', rollen: [] as string[] },
  { pfad: '/kunden', name: 'Kunden', rollen: ['sachbearbeiter', 'verwaltung'] },
  { pfad: '/vertraege', name: 'Verträge', rollen: ['sachbearbeiter', 'verwaltung'] },
  { pfad: '/rechnungen', name: 'Rechnungen', rollen: ['sachbearbeiter', 'abrechnung'] },
  { pfad: '/debitoren', name: 'Debitoren', rollen: ['sachbearbeiter', 'abrechnung'] },
  {
    pfad: '/marktkommunikation',
    name: 'Marktkommunikation',
    rollen: ['marktkommunikation', 'sachbearbeiter'],
  },
  { pfad: '/bilanzierung', name: 'Bilanzierung', rollen: ['verwaltung', 'abrechnung'] },
  { pfad: '/vertrieb', name: 'Vertrieb', rollen: ['sachbearbeiter', 'verwaltung'] },
  { pfad: '/produkte', name: 'Produkte', rollen: ['verwaltung', 'sachbearbeiter', 'abrechnung'] },
  {
    pfad: '/stromkennzeichnung',
    name: 'Stromkennzeichnung',
    rollen: ['verwaltung', 'sachbearbeiter'],
  },
  { pfad: '/aufbewahrung', name: 'Aufbewahrung', rollen: ['verwaltung'] },
]

export default function App() {
  return (
    <div className="geruest">
      <aside className="seitenleiste">
        <div className="marke">
          Stromvertrieb
          <span>Backoffice</span>
        </div>
        <nav>
          {bereiche
            .filter((bereich) => bereich.rollen.length === 0 || hat_rolle(...bereich.rollen))
            .map((bereich) => (
              <NavLink
                key={bereich.pfad}
                to={bereich.pfad}
                end={bereich.pfad === '/'}
                className={({ isActive }) => (isActive ? 'aktiv' : '')}
              >
                {bereich.name}
              </NavLink>
            ))}
        </nav>
        <div className="leistenfuss">
          <div>{benutzername()}</div>
          <button
            style={{ marginTop: 8, width: '100%' }}
            onClick={() => melde_ab()}
          >
            Abmelden
          </button>
        </div>
      </aside>
      <main className="inhalt">
        <Routes>
          <Route path="/" element={<Uebersicht />} />
          <Route path="/kunden" element={<Kunden />} />
          <Route path="/kunden/:kundennummer" element={<Kundenakte />} />
          <Route path="/vertraege" element={<Vertraege />} />
          <Route path="/vertraege/:vertragsnummer" element={<Vertragsakte />} />
          <Route path="/rechnungen" element={<Rechnungen />} />
          <Route path="/rechnungen/:rechnungsnummer" element={<Rechnungsblatt />} />
          <Route path="/debitoren" element={<Debitoren />} />
          <Route path="/marktkommunikation" element={<Marktkommunikation />} />
          <Route path="/bilanzierung" element={<Bilanzierung />} />
          <Route path="/vertrieb" element={<Vertrieb />} />
          <Route path="/produkte" element={<Produkte />} />
          <Route path="/stromkennzeichnung" element={<Stromkennzeichnung />} />
          <Route path="/aufbewahrung" element={<Aufbewahrung />} />
          <Route
            path="*"
            element={
              <>
                <h1>Nicht gefunden</h1>
                <p className="untertitel">Diese Seite gibt es nicht.</p>
              </>
            }
          />
        </Routes>
      </main>
    </div>
  )
}
